if (!customElements.get('de24-shop-request')) {
  customElements.define('de24-shop-request', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.fields = [...this.querySelectorAll('[data-label]')];
      this.whatsappLink = this.querySelector('[data-channel="whatsapp"]');
      this.subjectField = this.querySelector('input[name="contact[Betreff]"]');
      this.shopSubject = this.subjectField ? this.subjectField.value : '';
      const status = this.querySelector('.de24-request-status');
      const successDialog = this.querySelector('[data-request-success]');
      if (successDialog && typeof successDialog.showModal === 'function') {
        successDialog.querySelectorAll('[data-dismiss-success]').forEach(button => {
          button.addEventListener('click', () => successDialog.close(), { signal });
        });
        successDialog.addEventListener('close', () => status?.focus({ preventScroll: true }), { signal });
        if (!successDialog.open) successDialog.showModal();
      } else if (status) {
        status.focus({ preventScroll: true });
      }
      if (!this.whatsappLink) return;
      const type = this.querySelector('[data-shop-type]');
      this.typeField = type;
      const requested = new URLSearchParams(location.search).get('shop');
      const option = type && [...type.options].find(item => item.dataset.shop === requested);
      if (option) type.value = option.value;
      this.addEventListener('input', () => this.updateWhatsApp(), { signal });
      this.addEventListener('change', () => this.updateWhatsApp(), { signal });
      this.whatsappLink.addEventListener('click', event => {
        const invalid = this.fields.find(field => field.value.trim() && !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          invalid.reportValidity();
          return;
        }
        this.updateWhatsApp();
      }, { signal });
      this.updateWhatsApp();
    }
    /* 01.10.2026: "Textilien & Druck" ist eine normale Druckanfrage, kein Vereins- oder Firmenshop. */
    isTextildruck() {
      return this.typeField?.selectedOptions?.[0]?.dataset.shop === 'textildruck';
    }
    updateWhatsApp() {
      const druck = this.isTextildruck();
      const details = this.fields.filter(field => !(druck && field === this.typeField)).map(field => {
        const value = field.tagName === 'SELECT' ? field.selectedOptions[0].textContent.trim() : field.value.trim();
        return value ? `${field.dataset.label}: ${value}` : null;
      }).filter(Boolean);
      const greeting = druck
        ? 'Anfrage'
        : this.dataset.greeting;
      if (this.subjectField) this.subjectField.value = druck ? 'Anfrage' : this.shopSubject;
      const body = greeting + (details.length ? '\n\n' + details.join('\n\n') : '');
      this.whatsappLink.href = 'https://wa.me/' + this.dataset.phone + '?text=' + encodeURIComponent(body);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
